<script>
import TwoFactorSetupWrapper from '@/components/two-factor/TwoFactorSetupWrapper.vue';

export default {
  name: 'TwoFactorSetupRequired',
  components: {
    TwoFactorSetupWrapper
  },
  emits: ['setup-completed', 'cancel-setup'],
  methods: {
    handleSetupCompleted(result) {
      this.$emit('setup-completed', result);
    },

    handleSetupCancelled() {
      this.$emit('cancel-setup');
    },

    handleSetupError() {
      // Error is already handled by the wrapper component
      // Just emit cancel to go back to login
      this.$emit('cancel-setup');
    }
  }
};
</script>

<template>
  <TwoFactorSetupWrapper
    @setup-completed="handleSetupCompleted"
    @setup-cancelled="handleSetupCancelled"
    @setup-error="handleSetupError"
  />
</template>

 